import React, { Component } from 'react'

import AppBar from './ui/AppBar'

import Home from './container/home'
import Song from './container/song'
import Insights from './container/insights'

import PaymentForm from './container/payment-form'

import Signup from './container/signup'

import { Route } from 'react-router-dom'

import {APP_ROOT} from '../consts'

import { Container } from 'semantic-ui-react'

import 'typeface-roboto'
import './App.css'

export default class App extends Component {
  render () {
    return (
      <Container style={{height: '100%'}}>
        <AppBar />

        <div className={'app-container'} style={{height: '100%'}}>
          <Route path={`${APP_ROOT}/`} exact={true} component={Home} />
          <Route path={`${APP_ROOT}/song/:id`} exact={true} component={Song} />
          <Route path={`${APP_ROOT}/insights/:dashboard`} component={Insights} />
          <Route path={`${APP_ROOT}/payment`} exact={true} component={PaymentForm} />
          <Route path={`${APP_ROOT}/signup`} exact={true} component={Signup} />
        </div>

      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/App.js